export function elapsedSince(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  const hours = Math.floor(ms / 3_600_000);
  if (hours < 1) return '<1 Hour';
  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  if (days === 0) return `${hours} Hour${hours === 1 ? '' : 's'}`;
  return `${days} Day${days === 1 ? '' : 's'}${remHours ? ` ${remHours} Hour${remHours === 1 ? '' : 's'}` : ''}`;
}

export function fmtDateTime(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
